export const defaultLineColor = "#7083F0FF"
export const defaultPolygonFill = "#7083F040"
export const defaultPolygonOutline = defaultLineColor

export const polygonPatternMapping = {
    "hatch-1x": {
        x: 4,
        y: 4,
        width: 120,
        height: 120,
        mask: true,
    },
    "hatch-2x": {
        x: 132,
        y: 4,
        width: 120,
        height: 120,
        mask: true,
    },
    "hatch-cross": {
        x: 4,
        y: 132,
        width: 120,
        height: 120,
        mask: true,
    },
    dots: {
        x: 132,
        y: 132,
        width: 120,
        height: 120,
        mask: true,
    },
    default: {
        x: 4,
        y: 264,
        width: 120,
        height: 120,
        mask: true,
    },
}
